import { gql } from 'apollo-angular';

export const SITE_NICKNAME_MUTATION = gql`
  mutation PostSiteNickname($request: PostSiteNicknameRequestInput!) {
    PostSiteNickname(request: $request) {
      data
      isSuccess
      message
      errorCode
    }
  }
`;
